import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold leading-loose" }, "邮箱登录", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-subtle leading-normal" }, "邮箱找回助记词登录", -1)
const _hoisted_3 = { class: "pt-10 space-y-5" }
const _hoisted_4 = { class: "bg-gray-1 rounded-md mb-2.5" }
const _hoisted_5 = { class: "bg-gray-1 rounded-md" }
const _hoisted_6 = { class: "text-sm text-subtle py-4" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 登录 ")

import { computed, ref } from 'vue'
import { Dialog, Notify } from 'quasar'
import { useSafetyStore } from '@/store/user-safety'
import { SafetyInfo } from '@/types/user-safety'


export default /*#__PURE__*/_defineComponent({
  emits: ["exists", "switch-method"],
  setup(__props, { emit }: { emit: ({
    (e: 'exists', safetyInfo: SafetyInfo): void
    (e: 'switch-method'): void
}), expose: any, slots: any, attrs: any }) {



const backupStore = useSafetyStore()

const emailAddress = ref('')
const captcha = ref('')
const cooldown = ref(0)
const cooldownInterval = ref<undefined | number>(undefined)
const gettingCaptcha = ref(false)
const retrieving = ref(false)
const notifyMessage = ref('')

const emailRegExp = /[a-z0-9._]+@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/

const validEditingData = computed(() => {
    const validEmailAddress = emailRegExp.test(emailAddress.value)
    const validCaptcha = /^[0-9]{5}$/.test(captcha.value)
    return validEmailAddress && validCaptcha
})

function promptEmpty() {
    Dialog.create({
        title: '邮箱未绑定',
        message: '邮箱未绑定账号，请选择其他方式登录！',
        cancel: true,
        ok: {
            label: '手机登录',
            flat: true,
        },
    }).onOk(() => emit('switch-method'))
}

async function getCaptcha() {
    const exists = await backupStore.queryEmail(emailAddress.value)
    if (!exists) {
        promptEmpty()
        return
    }

    gettingCaptcha.value = true
    notifyMessage.value = ''
    backupStore
        .getCaptcha('email', emailAddress.value)
        .then(() => {
            notifyMessage.value = '短信验证码已发送，请耐心等待'
            cooldown.value = 60
            cooldownInterval.value = window.setInterval(() => {
                if (cooldown.value !== 0) cooldown.value--
                else window.clearInterval(cooldownInterval.value)
            }, 1000)
        })
        .catch((res) => Notify.create({ message: res, color: 'negative' }))
        .finally(() => (gettingCaptcha.value = false))
}

async function retrieveMnemonicEmail() {
    if (!validEditingData.value) return

    retrieving.value = true
    notifyMessage.value = ''

    try {
        const safetyInfo = await backupStore.retrieveWithEmail(emailAddress.value, captcha.value)
        if (Object.values(safetyInfo).length < 1) {
            promptEmpty()
            return
        }
        emit('exists', safetyInfo)
    } catch (error) {
        Notify.create(error instanceof Error ? error.message : (error as string))
    } finally {
        retrieving.value = false
    }
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_base_btn = _resolveComponent("base-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_q_input, {
          modelValue: emailAddress.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((emailAddress).value = $event)),
          autofocus: "",
          borderless: "",
          dense: "",
          type: "text",
          placeholder: "请输入邮箱"
        }, {
          prepend: _withCtx(() => [
            _createVNode(_component_q_icon, {
              class: "ml-4 mr-12",
              name: "mail"
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_q_input, {
          modelValue: captcha.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((captcha).value = $event)),
          onKeyup: _withKeys(retrieveMnemonicEmail, ["enter"]),
          "input-class": "placeholder-center text-center text-dark text-base font-bold",
          mask: "#####",
          borderless: "",
          dense: "",
          type: "text",
          placeholder: "请输入验证码"
        }, {
          after: _withCtx(() => [
            _createVNode(_component_base_btn, {
              onClick: getCaptcha,
              disable: gettingCaptcha.value || cooldown.value > 0 || !emailRegExp.test(emailAddress.value),
              loading: gettingCaptcha.value,
              color: cooldown.value > 0 ? 'subtle' : 'primary',
              style: {"width":"130px"},
              flat: "",
              dense: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(cooldown.value > 0 ? cooldown.value + 's 后再次获取' : '获取验证码'), 1)
              ]),
              _: 1
            }, 8, ["disable", "loading", "color"])
          ]),
          _: 1
        }, 8, ["modelValue", "onKeyup"])
      ])
    ]),
    _createElementVNode("p", _hoisted_6, _toDisplayString(notifyMessage.value), 1),
    _createVNode(_component_base_btn, {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (retrieveMnemonicEmail())),
      loading: retrieving.value,
      disable: gettingCaptcha.value || retrieving.value || !_unref(validEditingData),
      class: "w-full mb-2",
      padding: "8px"
    }, {
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }, 8, ["loading", "disable"])
  ]))
}
}

})